import { NetworkStatus } from '@apollo/client'
import { useEffect, useMemo, useRef } from 'react'
import { useGetBalancesQuery } from '../../../../../graphql/generated/graphql'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'

export const useDirectPayData = (accountId: string, type: string) => {
    const initialized = useRef(false)
    const { account, connectedNetwork } = useWeb3Connection()

    const { data, refetch, networkStatus } = useGetBalancesQuery({
        notifyOnNetworkStatusChange: true,
        variables: {
            address: account!,
            network: connectedNetwork,
            paymentLimitsInput: {
                accountId,
                type,
            },
        },
        skip: !account || !connectedNetwork,
        fetchPolicy: 'network-only',
    })

    // refetch data on network change
    useEffect(() => {
        if (!initialized.current) return
        if (account && connectedNetwork) refetch()
    }, [refetch, account, connectedNetwork])

    useEffect(() => {
        if (initialized.current) return
        if (data?.tokenBalances) initialized.current = true
    }, [data])

    const loading =
        networkStatus === NetworkStatus.loading || networkStatus === NetworkStatus.refetch

    const allTokenBalances = useMemo(() => {
        return data?.tokenBalances ?? []
    }, [data?.tokenBalances])

    return {
        loading,
        allTokenBalances,
        rewardsBalance: data?.rewardsBalance ?? 0,
        sdkConfig: data?.sdkConfig ?? [],
        limits: data?.paymentLimits ?? null,
    }
}
